import React, { useContext, useState } from 'react'
import { ContextGloball } from '../Context/ContextGlobal'
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;
function StockvsInvNoche() {
    const { setLoading } = useContext(ContextGloball);
    const [fecha, setFecha] = useState('');
    const [fechaInv, setFechaInv] = useState('');
    const [tipoDif, setTipoDif] = useState(0);
    const [datos, setDatos] = useState([]);
    function obtenerInformacion() {
        setLoading(true)
        var infoS = JSON.parse(localStorage.getItem('__react_session__'))
        fetch(`${server}/reporte/getStockInvNoche`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'regional': infoS.regional, fecha, fechaInv
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    //getInformacionProyeccion();
                    console.log(data.ok)
                    setDatos(data.ok);
                }

            })
            .catch(error => MsgUtils.msgError(error));
    }
    function colocarFecha(valor) {
        var fechi = valor.split('-');
        fechi = new Date(fechi[0], fechi[1] - 1, fechi[2]);
        fechi.setDate(fechi.getDate() - 1);
        var mes = parseInt(fechi.getMonth() + 1);
        mes = mes < 10 ? `0${mes}` : mes
        var dia = fechi.getDate();
        dia = dia < 10 ? `0${dia}` : dia
        setFechaInv(fechi.getFullYear() + '-' + mes + '-' + dia)
        setFecha(valor);
    }
    function getFiltro(dato){
        var result = dato.CANTIDAD == null ? (0 - dato.STOCK).toFixed(1) : (dato.CANTIDAD - dato.STOCK).toFixed(1)
        if(tipoDif==0){
            return true;
        }else if(tipoDif==1){
            return result!=0
        }else if(tipoDif==2){
            return result>0
        }else if(tipoDif==3){
            return result<0
        }else if(tipoDif==4){
            return result==0
        }
    }
    return (
        <>
            <div className='container-fluid bg-dark bg-gradient py-1'>
                <div className='row row-cols g-1'>
                    <div className='col' style={{ minWidth: '190px', maxWidth: '190px' }}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text text-light bg-transparent" style={{ border: 'none' }}>Fecha</span>
                            <input type="date" className="form-control" value={fecha} onChange={(e) => colocarFecha(e.target.value)}></input>
                        </div>
                    </div>
                    <div className='col' style={{ minWidth: '135px', maxWidth: '135px' }}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text text-light bg-transparent" style={{ border: 'none' }}>DIF</span>
                            <select className="form-select form-select-sm" value={tipoDif} onChange={(e) => setTipoDif(e.target.value)}>
                                <option value={0}>Todos</option>
                                <option value={1}>{'≠ 0'}</option>
                                <option value={2}>{'> 0'}</option>
                                <option value={3}>{'< 0'}</option>
                                <option value={4}>{'= 0'}</option>
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ minWidth: '100px', maxWidth: '100px' }}>
                        <button className='btn btn-secondary bg-gradient btn-sm' onClick={() => obtenerInformacion()}>
                            <i className="fa-solid fa-magnifying-glass"></i> Generar
                        </button>
                    </div>
                </div>
            </div>
            <div className='table-responsive'>
                <table className="table table-dark table-sm table-striped table-hover border-secondary table-bordered text-center">
                    <thead>
                        <tr>
                            <th scope="col">SUCURSAL</th>
                            <th scope="col">PRODUCTO</th>
                            <th scope="col">STOCK</th>
                            <th scope="col">INV. NOCHE</th>
                            <th scope="col">DIFF</th>
                        </tr>
                    </thead>
                    <tbody>
                        {datos.map((item, index) => {
                            if (getFiltro(item)) {
                                return (
                                    <tr key={index}>
                                        <th scope="row">{item.SUCURSAL}</th>
                                        <td>{item.DESCRIPCION}</td>
                                        <td>{item.STOCK.toFixed(1)}</td>
                                        <td>{item.CANTIDAD == null ? 0 : item.CANTIDAD.toFixed(1)}</td>
                                        <td>{item.CANTIDAD == null ? (0 - item.STOCK).toFixed(1) : (item.CANTIDAD - item.STOCK).toFixed(1)}</td>
                                    </tr>
                                )
                            }
                        })}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default StockvsInvNoche